import React, { Dispatch, SetStateAction } from "react";
import {
  ICommitteeMemberInput,
  IExecutiveMemberInput,
} from "../../exports/interfaces";
import { dynamicSuccess } from "../../hooks/useToast";
import Select from "react-select";
import {
  customSelectStyles,
  SelectOption,
} from "../../exports/customSelectStyles";
// import { locationData } from "../../exports/location";
import { Upload } from "lucide-react";
import { useOption } from "../../context/OptionContext";
import {
  renderExistingFilePreview,
  renderFilePreview,
} from "../../exports/functions";

const Committee = ({
  committeeactiveTab,
  committeeCooperative,
  setCommitteeCooperative,
  executiveCooperative,
  setExecutiveCooperative,
  errorsCommittee,
  errorsExecutive,
}: {
  committeeactiveTab: string;
  committeeCooperative: ICommitteeMemberInput;
  setCommitteeCooperative: Dispatch<SetStateAction<ICommitteeMemberInput>>;
  executiveCooperative: IExecutiveMemberInput;
  setExecutiveCooperative: Dispatch<SetStateAction<IExecutiveMemberInput>>;
  errorsCommittee: any;
  errorsExecutive: any;
}) => {
  const { categories } = useOption();
  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    inputFile: string,
    field?: string,
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      if (inputFile === "CommitteeMember") {
        setCommitteeCooperative((prev) => ({
          ...prev,
          ...(field === "bodFile"
            ? {
                bodFile: file,
                bodFileName: file.name,
                bodDocumentUrl: "",
              }
            : {
                fileName: file.name,
                file: file,
                documentUrl: "",
              }),
        }));
      } else {
        setExecutiveCooperative((prev) => ({
          ...prev,
          fileName: file.name,
          file: file,
          documentUrl: "",
        }));
      }
    }
  };

  const renderSelectValue = (
    options: SelectOption[],
    value: string | number,
  ) => {
    return options.find((opt) => opt.value === value) || null;
  };

  const committeeTypeOptions =
    categories
      ?.find((item) => item.name === "Committee Type")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const committeePositionOptions =
    categories
      ?.find((item) => item.name === "Committee Position")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const positionStatusOptions =
    categories
      ?.find((item) => item.name === "Position Status")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const educationOptions =
    categories
      ?.find((item) => item.name === "Education Level")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const executivePositionOptions =
    categories
      ?.find((item) => item.name === "Executive Position")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const executiveStatusOptions =
    categories
      ?.find((item) => item.name === "Position Status")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const genderOptions =
    categories
      ?.find((item) => item.name === "Gender")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

    

  // const issueddDistrictOptions = locationData.flatMap((province: any) => {
  //   const districts = Array.isArray(province.districts)
  //     ? province.districts
  //     : Object.values(province.districts || {});

  //   return districts.map((district: any) => ({
  //     label: district.name,
  //     value: district.name,
  //   }));
  // });

  const issueddDistrictOptions = categories
      ?.find((item) => item.name === "District")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  // const provinces = Array.isArray(locationData)
  //   ? locationData
  //   : Object.values(locationData || {});

  // const provinceOptions = provinces.map((province: any) => ({
  //   label: province.name,
  //   value: province.name,
  // }));

   const provinceOptions =
    categories
      ?.find((item) => item.name === "Province")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  // const selectedProvince: any = provinces.find(
  //   (province: any) => province.name === committeeCooperative.province,
  // );

  // const districtsRaw = selectedProvince?.districts ?? {};

  // const districts = Array.isArray(districtsRaw)
  //   ? districtsRaw
  //   : Object.values(districtsRaw);

  // const districtOptions = districts.map((district: any) => ({
  //   label: district.name,
  //   value: district.name,
  // }));
  
  const districtOptions =
    categories
      ?.find((item) => item.name === "District")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  // const selectedDistrict: any = districts.find(
  //   (d: any) => d.name === committeeCooperative.district,
  // );

  // const municipalitiesRaw = selectedDistrict?.municipalities ?? {};

  // const municipalities = Array.isArray(municipalitiesRaw)
  //   ? municipalitiesRaw
  //   : Object.values(municipalitiesRaw);

  // const municipalityOptions = municipalities.map((district: any) => ({
  //   label: district.name,
  //   value: district.name,
  // }));

  const municipalityOptions =
    categories
      ?.find((item) => item.name === "Municipality (Local Level)")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];
  // const selectedMunicipality: any = municipalities.find(
  //   (m: any) => m.name === committeeCooperative.municipality,
  // );
  // const wardsRaw = selectedMunicipality?.wards ?? [];

  // const wardOptions = (
  //   Array.isArray(wardsRaw) ? wardsRaw : Object.values(wardsRaw)
  // ).map((ward: any) => ({
  //   label: ward.toString(),
  //   value: ward.toString(),
  // }));

   const wardOptions =
    categories
      ?.find((item) => item.name === "Ward")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const handleCommitteeSelectChange = (
    name: keyof ICommitteeMemberInput,
    selected: SelectOption | null,
  ) => {
    setCommitteeCooperative((prev) => ({
      ...prev,
      [name]: name === "ward" ? Number(selected?.value) : selected?.value || "",
    }));
  };

  const handleExecutiveSelectChange = (
    name: keyof IExecutiveMemberInput,
    selected: SelectOption | null,
  ) => {
    setExecutiveCooperative((prev) => ({
      ...prev,
      [name]: name === "ward" ? Number(selected?.value) : selected?.value || "",
    }));
  };
  // const [committeeData, setCommitteeData] = useState<any[]>([]);

  // const [executiveData, setExecutiveData] = useState<any[]>([]);

  // const handleSaveCommittee = () => {
  //   setCommitteeData((prev) => [
  //     ...prev,
  //     { id: prev.length + 1, ...committeeForm },
  //   ]);

  //   setCommitteeForm({
  //     committeeType: "",
  //     position: "",
  //     fullName: "",
  //     gender: "",
  //     mobile: "",
  //     email: "",
  //     pan: "",
  //     nid: "",
  //     citizenship: "",
  //     issuedDistrict: "",
  //     tenureStart: "",
  //     tenureEnd: "",
  //     province: "",
  //     district: "",
  //     municipality: "",
  //     ward: "",
  //     street: "",
  //     education: "",
  //     file: null,
  //   });
  //   setFileName("");
  // };

  // const handleSaveExecutive = () => {
  //   setExecutiveData((prev) => [
  //     ...prev,
  //     { id: prev.length + 1, ...executiveForm },
  //   ]);

  //   setExecutiveForm({
  //     fullName: "",
  //     gender: "",
  //     mobile: "",
  //     email: "",
  //     pan: "",
  //     nid: "",
  //     citizenship: "",
  //     issuedDistrict: "",
  //     province: "",
  //     district: "",
  //     municipality: "",
  //     ward: "",
  //     street: "",
  //     experience: "",
  //     currentPosition: "",
  //     education: "",
  //     file: null,
  //   });
  //   setFileName("");
  // };

  const handleCommitteeChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;

    setCommitteeCooperative((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleExecutiveChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;

    setExecutiveCooperative((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDraft = () => {
    if (committeeactiveTab === "committees") {
      const { file, fileName, ...rest } = committeeCooperative;
      localStorage.setItem("committees", JSON.stringify(rest));
      dynamicSuccess("Committees saved as draft!");
    } else if (committeeactiveTab === "executive") {
      const { file, fileName, ...rest } = executiveCooperative;
      localStorage.setItem("executive", JSON.stringify(rest));
      dynamicSuccess("Executive saved as draft!");
    }
  };

  return (
    <>
      <div className={`dashboard-card`} style={{ borderTopLeftRadius: 0 }}>
        <div className="row g-3">
          <div className="col-12">
            {committeeactiveTab === "committees" && (
              <>
                <div className="dashboard-card">
                  <div className="row g-4">
                    <div className="col-md-4">
                      <label className="form-label">
                        Committee Type <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={committeeTypeOptions}
                        placeholder="Select committee type"
                        value={renderSelectValue(
                          committeeTypeOptions,
                          committeeCooperative.committeeType,
                        )}
                        onChange={(selected) =>
                          handleCommitteeSelectChange("committeeType", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Position <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={committeePositionOptions}
                        placeholder="Select position"
                        value={renderSelectValue(
                          committeePositionOptions,
                          committeeCooperative.position,
                        )}
                        onChange={(selected) =>
                          handleCommitteeSelectChange("position", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Position Status <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={positionStatusOptions}
                        placeholder="Select status"
                        value={renderSelectValue(
                          positionStatusOptions,
                          committeeCooperative.positionStatus,
                        )}
                        onChange={(selected) =>
                          handleCommitteeSelectChange(
                            "positionStatus",
                            selected,
                          )
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                  </div>
                </div>

                <div className="dashboard-card mt-3">
                  <div className="row g-4">
                    <div className="col-md-4">
                      <label className="form-label">
                        Grandfather / Grandmother Name{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="grandmotherName"
                        className="form-control  "
                        placeholder="Enter name here"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.grandmotherName}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">
                        Father / Mother Name{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="fatherName"
                        className="form-control  "
                        placeholder="Enter name here"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.fatherName}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Husband / Wife Name{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="husbandName"
                        className="form-control  "
                        placeholder="Enter name here"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.husbandName}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Full Name <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        className="form-control  "
                        placeholder="Enter Address here"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.fullName}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Citizenship Number{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="citizenship"
                        className="form-control  "
                        placeholder="Enter Citizenship number here"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.citizenship}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        PAN Number
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="pan"
                        className="form-control"
                        placeholder="Enter PAN number here"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.pan}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        NID Number <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="nid"
                        className="form-control  "
                        placeholder="Enter NID number here"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.nid}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Email Address <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="email"
                        className="form-control"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.email}
                        placeholder="Enter Email address here"
                      />
                      {errorsCommittee.email && (
                        <p className="error-message">{errorsCommittee.email}</p>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Issued District <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={issueddDistrictOptions}
                        placeholder="Select Issued District"
                        value={renderSelectValue(
                          issueddDistrictOptions,
                          committeeCooperative.issuedDistrict,
                        )}
                        onChange={(selected) =>
                          handleCommitteeSelectChange(
                            "issuedDistrict",
                            selected,
                          )
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Tenure Start Date{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="date"
                        name="tenureStart"
                        className="form-control"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.tenureStart}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Tenure end date <span className="primary-color">*</span>
                      </label>
                      <input
                        type="date"
                        name="tenureEnd"
                        className="form-control"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.tenureEnd}
                      />
                    </div>
                  </div>
                </div>
                <div className="dashboard-card mt-3">
                  <div className="row g-4">
                    <div className="col-md-4">
                      <label className="form-label">
                        Province <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={provinceOptions}
                        placeholder="Select Province"
                        value={renderSelectValue(
                          provinceOptions,
                          committeeCooperative.province,
                        )}
                        onChange={(selected) =>
                          handleCommitteeSelectChange("province", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        District <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={districtOptions}
                        placeholder="Select District"
                        value={renderSelectValue(
                          districtOptions,
                          committeeCooperative.district,
                        )}
                        onChange={(selected) =>
                          handleCommitteeSelectChange("district", selected)
                        }
                        noOptionsMessage={() =>
                          !committeeCooperative.province
                            ? "Select province"
                            : "No options"
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Municipality(Local Level){" "}
                        <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={municipalityOptions}
                        placeholder="Select municipality"
                        value={renderSelectValue(
                          municipalityOptions,
                          committeeCooperative.municipality,
                        )}
                        onChange={(selected) =>
                          handleCommitteeSelectChange("municipality", selected)
                        }
                        noOptionsMessage={() =>
                          !committeeCooperative.district
                            ? "Select district"
                            : "No options"
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Ward <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={wardOptions}
                        placeholder="Select ward"
                        value={
                          wardOptions.find(
                            (option) =>
                              Number(option.value) ===
                              committeeCooperative.ward,
                          ) || null
                        }
                        onChange={(selected) =>
                          handleCommitteeSelectChange("ward", selected)
                        }
                        noOptionsMessage={() =>
                          !committeeCooperative.municipality
                            ? "Select municipality"
                            : "No options"
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Street\Tole <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="street"
                        className="form-control"
                        placeholder="Enter Street\tole. here"
                        onChange={handleCommitteeChange}
                        value={committeeCooperative.street}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Highest level of education{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={educationOptions}
                        placeholder="Select level"
                        value={renderSelectValue(
                          educationOptions,
                          committeeCooperative.education || "",
                        )}
                        onChange={(selected) =>
                          handleCommitteeSelectChange("education", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label">
                        Upload Committee Member Photo (JPEG, PNG)
                      </label>

                      <div
                        className={`upload-box p-4 ${!committeeCooperative.file && !committeeCooperative.documentUrl && "text-center"}`}
                      >
                        {committeeCooperative.file ? (
                          renderFilePreview(
                            committeeCooperative.file,
                            committeeCooperative.fileName,
                            (e: any) =>
                              handleFileChange(e, "CommitteeMember", "photo"),
                          )
                        ) : committeeCooperative.documentUrl ? (
                          renderExistingFilePreview(
                            committeeCooperative.documentUrl,
                            (e: any) =>
                              handleFileChange(e, "CommitteeMember", "photo"),
                          )
                        ) : (
                          <>
                            <Upload />

                            <p className="mb-1">
                              Choose a file or drag and drop it here.
                            </p>

                            <small className="d-block mb-3">
                              (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                            </small>

                            <label className="btn btn-badge text-main-color">
                              Browse file
                              <input
                                hidden
                                type="file"
                                onChange={(e) => {
                                  handleFileChange(
                                    e,
                                    "CommitteeMember",
                                    "photo",
                                  );
                                }}
                              />
                            </label>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`dashboard-card  mt-3`}>
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="mb-3">
                        <h6>Board of Director and Audit Committee</h6>
                        <small>BOD Documents</small>
                      </div>
                      <label className="form-label">
                        Upload Document (PDF, JPEG, PNG)
                      </label>
                      <div
                        className={`upload-box p-4 ${!committeeCooperative.bodFile && !committeeCooperative.bodDocumentUrl && "text-center"}`}
                      >
                        {committeeCooperative.bodFile ? (
                          renderFilePreview(
                            committeeCooperative.bodFile,
                            committeeCooperative.bodFileName,
                            (e: any) =>
                              handleFileChange(e, "CommitteeMember", "bodFile"),
                          )
                        ) : committeeCooperative.bodDocumentUrl ? (
                          renderExistingFilePreview(
                            committeeCooperative.bodDocumentUrl,
                            (e: any) =>
                              handleFileChange(e, "CommitteeMember", "bodFile"),
                          )
                        ) : (
                          <>
                            <Upload />

                            <p className="mb-1">
                              Choose a file or drag and drop it here.
                            </p>

                            <small className="d-block mb-3">
                              (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                            </small>

                            <label className="btn btn-badge text-main-color">
                              Browse file
                              <input
                                hidden
                                type="file"
                                onChange={(e) => {
                                  handleFileChange(
                                    e,
                                    "CommitteeMember",
                                    "bodFile",
                                  );
                                }}
                              />
                            </label>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex mt-4 justify-content-end">
                  <button
                    className="btn btn-badge-primary px-3"
                    onClick={handleDraft}
                  >
                    Add Member
                  </button>
                </div>
              </>
            )}
            {committeeactiveTab === "executive" && (
              <>
                <div className="dashboard-card">
                  <div className="row g-4">
                    <div className="col-md-4">
                      <label className="form-label">
                        Position <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={executivePositionOptions}
                        placeholder="Select position"
                        value={renderSelectValue(
                          executivePositionOptions,
                          executiveCooperative.position,
                        )}
                        onChange={(selected) =>
                          handleExecutiveSelectChange("position", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Position Status <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={executiveStatusOptions}
                        placeholder="Select status"
                        value={renderSelectValue(
                          executiveStatusOptions,
                          executiveCooperative.positionStatus,
                        )}
                        onChange={(selected) =>
                          handleExecutiveSelectChange(
                            "positionStatus",
                            selected,
                          )
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                  </div>
                </div>
                <div className="dashboard-card mt-3">
                  <div className="row g-4">
                    <div className="col-md-4">
                      <label className="form-label">
                        Grandfather / Grandmother Name{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="grandmotherName"
                        className="form-control  "
                        placeholder="Enter name here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.grandmotherName}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">
                        Father / Mother Name{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="fatherName"
                        className="form-control  "
                        placeholder="Enter name here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.fatherName}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Husband / Wife Name{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="husbandName"
                        className="form-control  "
                        placeholder="Enter name here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.husbandName}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Full Name <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        className="form-control  "
                        placeholder="Enter Name here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.fullName}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Gender <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={genderOptions}
                        placeholder="Select gender"
                        value={renderSelectValue(
                          genderOptions,
                          executiveCooperative.gender,
                        )}
                        onChange={(selected) =>
                          handleExecutiveSelectChange("gender", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Mobile Number <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="mobile"
                        className="form-control"
                        placeholder="Enter mobile number here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.mobile}
                      />
                      {errorsCommittee.mobile && (
                        <p className="error-message">
                          {errorsCommittee.mobile}
                        </p>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Email Address <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="email"
                        className="form-control"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.email}
                        placeholder="Enter Email address here"
                      />
                      {errorsExecutive.email && (
                        <p className="error-message">{errorsExecutive.email}</p>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Address <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="address"
                        className="form-control  "
                        placeholder="Enter Address here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.address}
                      />
                    </div>
                  </div>
                </div>
                <div className="dashboard-card mt-3">
                  <div className="row g-4">
                    <div className="col-md-4">
                      <label className="form-label">
                        Citizenship Number{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="citizenship"
                        className="form-control  "
                        placeholder="Enter Citizenship number here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.citizenship}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        PAN Number
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="pan"
                        className="form-control"
                        placeholder="Enter PAN number here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.pan}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        NID Number <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="nid"
                        className="form-control  "
                        placeholder="Enter NID number here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.nid}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Issued District <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={issueddDistrictOptions}
                        placeholder="Select issued district"
                        value={renderSelectValue(
                          issueddDistrictOptions,
                          executiveCooperative.issuedDistrict,
                        )}
                        onChange={(selected) =>
                          handleExecutiveSelectChange(
                            "issuedDistrict",
                            selected,
                          )
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Province <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={provinceOptions}
                        placeholder="Select province"
                        value={renderSelectValue(
                          provinceOptions,
                          executiveCooperative.province,
                        )}
                        onChange={(selected) =>
                          handleExecutiveSelectChange("province", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        District <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={districtOptions}
                        placeholder="Select district"
                        value={renderSelectValue(
                          districtOptions,
                          executiveCooperative.district,
                        )}
                        onChange={(selected) =>
                          handleExecutiveSelectChange("district", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Municipality(Local Level){" "}
                        <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={municipalityOptions}
                        placeholder="Select municipality"
                        value={renderSelectValue(
                          municipalityOptions,
                          executiveCooperative.municipality,
                        )}
                        onChange={(selected) =>
                          handleExecutiveSelectChange("municipality", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Ward <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={wardOptions}
                        placeholder="Select ward"
                        value={
                          wardOptions.find(
                            (option) =>
                              Number(option.value) ===
                              executiveCooperative.ward,
                          ) || null
                        }
                        onChange={(selected) =>
                          handleExecutiveSelectChange("ward", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Street\Tole <span className="primary-color">*</span>
                      </label>
                      <input
                        type="text"
                        name="street"
                        className="form-control"
                        placeholder="Enter Street\tole. here"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.street}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">
                        Highest level of education{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <Select
                        styles={customSelectStyles}
                        options={educationOptions}
                        placeholder="Select education"
                        value={renderSelectValue(
                          educationOptions,
                          executiveCooperative.education,
                        )}
                        onChange={(selected) =>
                          handleExecutiveSelectChange("education", selected)
                        }
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Years of Experience{" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="experience"
                        className="form-control with-spin"
                        placeholder="0"
                        onChange={handleExecutiveChange}
                        value={executiveCooperative.experience || ""}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Duration in Current Position (years){" "}
                        <span className="primary-color">*</span>
                      </label>
                      <input
                        type="number"
                        name="currentPositionDuration"
                        className="form-control"
                        placeholder="0"
                        onChange={handleExecutiveChange}
                        value={
                          executiveCooperative.currentPositionDuration || ""
                        }
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label">
                        Upload Committee Member Photo (JPEG, PNG)
                      </label>

                       <div
                        className={`upload-box p-4 ${!executiveCooperative.file && !executiveCooperative.documentUrl && "text-center"}`}
                      >
                        {executiveCooperative.file ? (
                          renderFilePreview(
                            executiveCooperative.file,
                            executiveCooperative.fileName,
                            (e: any) =>
                              handleFileChange(e, "ExecutiveMember"),
                          )
                        ) : executiveCooperative.documentUrl ? (
                          renderExistingFilePreview(
                            executiveCooperative.documentUrl,
                            (e: any) =>
                              handleFileChange(e, "ExecutiveMember"),
                          )
                        ) : (
                          <>
                            <Upload />

                            <p className="mb-1">
                              Choose a file or drag and drop it here.
                            </p>

                            <small className="d-block mb-3">
                              (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                            </small>

                            <label className="btn btn-badge text-main-color">
                              Browse file
                              <input
                                hidden
                                type="file"
                                onChange={(e) => {
                                  handleFileChange(
                                    e, "ExecutiveMember"
                                  );
                                }}
                              />
                            </label>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex mt-4 justify-content-end">
                  <button
                    className="btn btn-badge-primary px-3"
                    onClick={handleDraft}
                  >
                    Add Member
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* {committeeactiveTab === "committees" && committeeData.length > 0 && (
        <CommiteeTable committeeData={committeeData} />
      )} */}
      {/* {committeeactiveTab === "executive" && executiveData.length > 0 && (
        <ExecutiveTable executiveData={executiveData} />
      )} */}
    </>
  );
};

export default Committee;
